module.exports = __webpack_public_path__ + "img/ocean_bg.5c5d2389.png";